<template>
    <div id="caseLink">
        <ul>
            <li @click="returnTop('#scopeBusiness')">解决方案</li>
            <li @click="returnTop('#operationFlow')">解决方案流程</li>
            <li @click="returnTop('#systemOptimization')">系统优化</li>
            <li @click="returnTop('#trackService')">跟踪服务</li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'List1',
    methods:{
        returnTop:function(dis){
            document.querySelector(dis).scrollIntoView({behavior:'smooth',block:'center'});
        }
    }
}
</script>

<style scoped>
    #caseLink{
        background: #edf0f5;
        line-height: 45px;
    }
    #caseLink>ul{
        width: 1050px;
        margin: 0 auto;
        overflow: hidden;
        padding:0 35px;
    }
    #caseLink>ul>li{
        float: left;
        text-align: center;
        width: 24%;
        cursor: pointer;
        font-size: 16px;
    }
    #caseLink>ul>li:nth-child(2){
        padding-right: 4%;
    }
    #caseLink>ul>li:first-child{
        text-align: left;
    }
    #caseLink>ul>li:last-child{
        text-align: right;
    }
</style>
